interface MarketingTarget {
  key: string;
  text: string;
}

interface MarketingTargetLogo {
  key: string;
  url: string;
}

const defaultText = '모든'
const defaultLogoUrl = 'landing/ibk_logo.png'

export const marketingTargets: MarketingTarget[] = [
  {
    key: 'bizbot',
    text: '비즈봇',
  },
  {
    key: 'businesson',
    text: '스마트빌',
  },
  {
    key: 'hstns',
    text: '효성TNS',
  },
  {
    key: 'modusign',
    text: '모두싸인',
  },
  {
    key: 'medigatte',
    text: '메디게이트',
  },
  {
    key: 'goodoc',
    text: '굿닥',
  },
  {
    key: 'youngjin',
    text: '영진에셋',
  },
  {
    key: 'kcd',
    text: '캐시노트',
  },
]

const logoList: MarketingTargetLogo[] = [
  {
    key: 'knbnk',
    url: 'landing/bnk_logo.png',
  },
] 

export const getTargetText = (key: string) => {
  const target = marketingTargets.find((item) => item.key === key)
  return target?.text || defaultText
}


export const getTargetLogoUrl = (key: string) => {
  const target = logoList.find((item) => item.key === key)
  return target?.url || defaultLogoUrl
}
